import styled from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const Header = styled.div<IWithSize>`
  display: flex;
  align-items: center;
  padding: ${({ size }) =>
    size
      ? `${15 * size}px ${3 * size}px ${15 * size}px ${15 * size}px`
      : '15px 3px 15px 15px'};
`

export default Header
